import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Popover, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiPirate, mdiSwapHorizontal } from '@mdi/js';
import Icon from '@mdi/react';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemShift2 } from '../../../../../resources/types';
import { buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, getUser, setLoading, setParameters } from '../../../../commons/functions';
import PopOverContact from '../../../../../components/extras/PopOverContact';

export const OPSPlanningShiftsPage = () => {
  const { data, menu, parameters, idUser } = useGlobalState();

  const [keyw, setKeyw] = useState<string>("");

  //const storeAdmin = useStoreAdmin();



  const [shifts, setShifts] = useState<ItemShift2[]>([]);
  const [shiftsMaster, setShiftsMaster] = useState<[]>([]);

  const [filteringText, setFilteringText] = useState('');
  const [sortingColumn, setSortingColumn] = useState({
    sortingField: 'registration',
    isDescending: false,
  });




  useEffect(() => {
    handleRefresh()
  }, [parameters]);
  const handleRefresh = async () => {
    try {
      setLoading(true);

      let body: any = {
        month: parameters.month,
        year: parameters.year,
        orderBy: "dateShift",
        order: "asc",
      }

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/shifts/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.shifts) {

        setShiftsMaster(data.shifts)
        setShifts(pivotShifts(data.shifts))



      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const pivotShifts = (data: any[]): ItemShift2[] => {
    const grouped = data.reduce((acc: any, item: any) => {
      const date = item.dateShift;

      // Initialize the date group if it doesn't exist
      if (!acc[date]) {
        acc[date] = {
          dateShift: date,
          idShift: item.idShift,
          isSelling: item.isSelling,
          isToday: item.isToday,
          isPast: item.isPast,
          isFuture: item.isFuture,
          AM: null,
          PM: null,
          DIR: null
        };
      }
      if (acc[date].hasOwnProperty(item.shift)) {
        acc[date][item.shift] = item;
      }

      return acc;
    }, {});
    return Object.values(grouped);
  };

  useEffect(() => {
    handleRefresh();
  }, []);


  const filteredShifts: ItemShift2[] = shifts.filter((item) => {
    const normalize = (str: string | undefined | null) =>
      (str || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
    const searchWords = normalize(filteringText).split(/\s+/).filter(Boolean);
    const text = normalize([item.dateShift, item?.AM?.user ?? "", item?.PM?.user ?? "", item?.DIR?.user ?? ""].join(" "));
    return searchWords.every((word) => text.includes(normalize(word)));
  });



  return (
    <CustomAppLayout
      toolsHide={true}
      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        < SpaceBetween size="xs" >
          <Header actions={


            <SpaceBetween direction="horizontal" size="xs">
              <Favorites />
            </SpaceBetween>
          }>
            Turnos { }

          </Header>
          <Table

            stripedRows
            stickyHeader
            variant='embedded'
            cellVerticalAlign="top"
            filter={
              <SpaceBetween direction='horizontal' size='xs'>

                <div style={{ width: 130 }}>
                  <MPModal
                    width={120}
                    today prevMonth nextMonth
                    end={(() => { const d = new Date(); d.setMonth(d.getMonth() + 1); return d; })()}
                    date={`${parameters.period}`}
                    onConfirm={(date) => {
                      setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                    }}
                  />
                </div>
                <TextFilter filteringText={filteringText} onChange={({ detail }) => {
                  setFilteringText(detail.filteringText);
                }} />
              </SpaceBetween>
            }
            //onRowClick={({ detail }) => handleRowClick(detail.item)}
            columnDefinitions={[
              {
                id: "dateShift",
                header: "Fecha",
                width: 120,
                cell: (item) => (
                  <FormField
                    description={
                      item?.DIR?.isSelling === 2 ?
                        <BadgeCustom color="violet" >Vendido</BadgeCustom>
                        : item?.DIR?.isSelling === 1 ? <BadgeCustom color="lime" >En venta</BadgeCustom> : null
                    }
                    label={item.dateShift} />
                )
              },
              {
                id: "userDirector",
                header: "Director",
                cell: (item) =>
                  item.DIR && (
                    <FormField
                      description={
                        <>

                          {item.DIR.userOld !== "" ? <>
                            <Icon path={mdiSwapHorizontal} size={1} /> {item.DIR.userOld}
                          </> : ""}

                          {item.DIR.idUserMercenary !== 0 ? <>
                            <Icon path={mdiSwapHorizontal} size={1} /> {item.DIR.user}
                          </> : ""}
                        </>
                      }
                      label={

                        <SpaceBetween direction="horizontal" size="xs">
                          {item.DIR.idUserMercenary !== 0 && (<Icon path={mdiPirate} size={0.75} />)}
                          {item.DIR.idUserMercenary !== 0 ?
                            <PopOverContact idUser={item.DIR.idUserMercenary} />
                            :
                            <PopOverContact idUser={item.DIR.idUser} />
                          }
                        </SpaceBetween>

                      }
                    >
                    </FormField>
                  )

                //sortingField: "displayName",
              },
              {
                id: "userTow1",
                header: "Remolcador AM",
                cell: (item) =>
                  item.AM && (
                    <FormField
                      info={
                        <PopOverContact idUser={item.AM.idUser} hideUser />}
                      constraintText={
                        item.AM.userOld !== ""
                          ? <>
                            <Icon path={mdiSwapHorizontal} size={1} /> {item.AM.userOld}
                          </>
                          : null
                      }
                      label={item.isFuture === 1 ? item.AM.user : <>{item.AM.user}</>}
                    />
                  )

                //sortingField: "displayName",
              },
              {
                id: "userTow2",
                header: "Remolcador PM",
                cell: (item) =>
                  item.PM && (
                    <FormField
                      info={
                        <PopOverContact idUser={item.PM.idUser} hideUser />}
                      constraintText={
                        item.PM.userOld !== ""
                          ? <>
                            <Icon path={mdiSwapHorizontal} size={1} /> {item.PM.userOld}
                          </>
                          : null
                      }
                      label={item.isFuture === 1 ? item.PM.user : <>{item.PM.user}</>}
                    />
                  )

                //sortingField: "displayName",
              },
            ]}
            items={filteredShifts}
            selectionType={undefined}
            trackBy="idShift"
          />
        </SpaceBetween >
      }
    />

  );
};
